// extracted by mini-css-extract-plugin
export default {"container":"Bubbles_container__SwPIi","circle":"Bubbles_circle__yGFWs","tooltip":"Bubbles_tooltip__S8BgE","active":"Bubbles_active__1IiT3"};